import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PatientService } from '../shared/patient.service';

@Component({
  selector: 'app-ratelist',
  templateUrl: './ratelist.component.html',
  styleUrls: ['./ratelist.component.css']
})
export class RatelistComponent implements OnInit {

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  listData: MatTableDataSource<any>;
  displayedColumns: string[] = ['testname', 'specimenname', 'rate'];
  
  
  constructor(public patientservice: PatientService) { }

  ngOnInit(): void {
    this.loadratelist();
  }

  loadratelist()
  {
    this.patientservice.getAllTestRates().subscribe((data : any) => {this.listData =new MatTableDataSource(data);
      if (data != undefined)
      {
        this.listData.sort = this.sort;
        this.listData.paginator = this.paginator;  
      }
      });    
  }
  applyFilter(filtervalue : string)
  {
    this.listData.filter = filtervalue.trim().toLowerCase();
  }

}
